"use client";

import { createContext, useContext } from "react";
import type { MessageSummary } from "@/types/message";
export type ChatChannel = NonNullable<MessageSummary["channel"]> | "call" | "email";
export const CHAT_CHANNELS = ["sms", "patient_portal", "web_chat", "call", "email"] as const satisfies readonly ChatChannel[];
export interface ChatFilterContextValue {
  /** Kinds of thread item to show. Empty shows everything. */
  channels: ReadonlySet<ChatChannel>;
  toggleChannel: (channel: ChatChannel) => void;
  clearChannels: () => void;
  /** What's typed in the search box. */
  search: string;
  setSearch: (search: string) => void;
  /** The debounced search the thread is filtered by. */
  searchQuery: string;
  /** Whether any channel or search is applied. */
  isFiltered: boolean;
  /** Clears both the channels and the search. */
  clearFilters: () => void;
}
export const ChatFilterContext = createContext<ChatFilterContextValue | null>(null);
export function useChatFilterContext() {
  const context = useContext(ChatFilterContext);
  if (!context) {
    throw new Error("useChatFilterContext must be used within a ChatFilterProvider");
  }
  return context;
}